export {
    TypingIndicator,
    LoadingIndicator
} from './Loading';
export type {
    LoadingProps,
    IndicatorProps
} from './Loading';
